import { Component, OnInit } from "@angular/core";
import {UtilService} from "../../helpers/util.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { IdnowBackendsService } from 'src/app/services/idnow-backend-services';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: "idnow-input-rut",
  templateUrl: "./input-rut.component.html",
  styleUrls: ["./input-rut.component.css"]
})
export class InputRutComponent implements OnInit {
  companyForm: FormGroup;
  endingButton = false;
  cedula : string;

  constructor(private utilService: UtilService, private formBuilder: FormBuilder, private notificationService: NotificationService,
              private router: Router, private idnowservices : IdnowBackendsService) { }

  ngOnInit(): void {
    this.initBlankFields();
    this.saveClientIP();
  }

  saveClientIP(){
    this.idnowservices.getIPAddress().subscribe((res:any)=>{  
      localStorage.setItem("clientIP", res.ip);  
    }); 
  }

  formatRUT(focusEvent) {
    const resp = this.utilService.formatearEventRut(focusEvent);
    this.companyForm.controls["rut"].setValue(resp.rut);
    if (resp.error) {
      this.companyForm.controls["rut"].setErrors({"error": true});
    }
  }

  public restrictNumeric(event) {
    let k;
    k = event.charCode;
    return ((k > 96 && k < 123) || k === 8 || k === 75 || (k >= 48 && k <= 57));
  }

  private initBlankFields() {
    this.companyForm = this.formBuilder.group({
      rut: ["", Validators.required],
    });
  }

  errorHandling(control: string, error: string) {
    this.utilService.errorHandling(control, error,  this.companyForm, this.endingButton);
  }

  onConfirmClick(form: any): void {
    this.endingButton = true;
    if (form.valid) {
      const formRecived = Object.assign(form.value);
      
      let uuidTransaction = uuidv4();

      localStorage.setItem("uuidTransaction", uuidTransaction);

      this.idnowservices.initOOBEnrollment(formRecived.rut.replace("-", "").replace(/\./g,''), uuidTransaction, 
        () => this.router.navigateByUrl("/steps")
      )
    } else {
      this.notificationService.showError("Complete los campos obligatorios correctamente para continuar", "Error");
    }
  }
}
